import {Component, OnInit, Input, EventEmitter, Output, AfterViewInit, OnDestroy} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { NavigationService, PermisosService, ABMRolesService, SpinnerService} from '../../../services';
import { PATH_ABM } from '../../../navigation/navigation.module';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { MdSnackBar } from '@angular/material';

@Component({
  selector: 'app-permisos-detail',
  templateUrl: './permisos-detail.component.html',
  styleUrls: ['./permisos-detail.component.scss']
})
export class PermisosDetailComponent implements OnInit, AfterViewInit, OnDestroy {

  permisoId = null;
  permisoName = 'Nuevo Permiso';
  editNameMode = false;
  descripcion = '';
  descError = false;
  productos = [];
  productosValid = true;
  accionesActuales = [];

  // las mainActions son las acciones "padre"
  mainActions = [];

  @Input() visualize = false;
  permisoToLoad = null;

  permisoLoaded = null;

  permisoLoading = false;

  private firstLoad = false;

  actions = [];
  actionsSubscriber: any;

  @Output() Initialized = new EventEmitter<{}>();

  constructor(private route: ActivatedRoute,
              private navService: NavigationService,
              private location: Location,
              private router: Router,
              private permisosService: PermisosService,
              private abmRolesService: ABMRolesService,
              private snackBar: MdSnackBar,
              private spinnerService: SpinnerService) {
    this.permisosService.verificarAccesoDeURL();
    this.actionsSubscriber = this.permisosService.actionsToEdit.subscribe(x => {
      // filtramos la accion Eliminar empresa/prospecto y rechazar precio especial dado que ya no se dispone de dichas características
      this.mainActions = x.filter(y => y.ParentId === null && y.Id !== 25 && y.Id !== 13);
    });
    this.permisosService.loadOptions();

    this.abmRolesService.getProductos()
      .subscribe( response => {
        this.productos = response;
        // si se está creando un nuevo permiso, asignar a todos los productos la propiedad checked = true
        this.productos.forEach(x => {
          x.checked = true;
        });
        if (this.visualize) {
          this.setupData(this.permisoLoaded);
        }
      });
  }

  /**
  AccionId: 1
  AccionParentID: null
  Descripcion: "Pantalla de ABM"
  Nombre: "P_ABM"
  **/

  ngOnInit() {
    this.route.params.subscribe(params => {
      console.log(this.location.path());
      this.permisoId = this.route.snapshot.params['id'];

      if (!this.visualize) {
        if (this.permisoId) {
          this.loadData();
        } else {
          // seteamos las acciones y enviamos un Id que no existe para que traiga todas las acciones sin marcar
          this.permisosService.setActionsToEdit([-1]);
        }
      }


      this.firstLoad = true;
    });
  }

  ngAfterViewInit() {
    setTimeout(_ => {
      this.Initialized.emit();
    });
  }

  ngOnDestroy() {
    this.actionsSubscriber.unsubscribe();
  }

  loadData() {
    this.spinnerService.setShowFlag(true);
    if (this.permisoId) {
      this.permisosService.getPermisoById(this.permisoId).subscribe(res => {
        if (res) {
          this.setupData(res);
        }
        this.spinnerService.setShowFlag(false);
      }, err => this.spinnerService.setShowFlag(false));
    }
  }

  setupData(res) {
    this.permisoName = res.Nombre;
    this.descripcion = res.Descripcion;
    this.productos.forEach(x => {
      x.checked = res.Productos.findIndex(y => y.Id === x.Id) > -1;
    });
    // le entregamos las acciones al servicio para tenerlas disponibles para todos los componentes
    // en el constructor nos suscribimos al subject para obtener las acciones pertienentes a las acciones raices
    this.actions = res.Acciones.map(x => x.AccionId);
    this.permisosService.setActionsToEdit(this.actions);
  }

  onSubmit() {
    this.checkValidDescription();
    if (this.permisoName === 'No Valido' || !this.productosValid || !this.descripcion.trim().length) {
      this.snackBar.open('El formulario no está completo. Por favor, complete el formulario y reintente.', '', {
        duration: 3000,
      });
      return;
    }
    const productos = this.productos.filter(x => x.checked).map(x => x.Id);
    this.spinnerService.setShowFlag(true);
    if (this.permisoId) {
      // estamos editando
      this.permisosService.updatePermiso(this.permisoId, productos, this.permisoName, this.descripcion).subscribe(x => {
        this.spinnerService.setShowFlag(false);
        if (x) {
          this.onNavigateBack();
        }
      }, err => {
        this.spinnerService.setShowFlag(false);
        this.snackBar.open('Ocurrio un error al intentar guardar el Permiso. Intente Nuevamente.', '', {
          duration: 3000,
        });
      });

    } else {
      // estamos creando
      this.permisosService.createPermiso(productos, this.permisoName, this.descripcion.trim())
        .subscribe(x => {
          this.spinnerService.setShowFlag(false);
          if (x) {
            this.onNavigateBack();
          }
        }, err => {
          this.spinnerService.setShowFlag(false);
          this.snackBar.open('Ocurrio un error al intentar guardar el Permiso. Intente Nuevamente.', '', {
            duration: 3000,
          });
        });
    }
  }

  onNavigateBack() {
    if (this.navService.isBackBtnReady()) {
      this.location.back();
    } else {
      this.router.navigateByUrl('/' + PATH_ABM + '/permisos');
    }
  }

  getChildItems(action) {
    return this.permisosService.getDirectChilds(action);
  }

  onProductoChecked(prod, e) {
    prod.checked = e.checked;
    let somechecked = false;
    this.productos.forEach( x => {
      if (x.checked === true) {
        somechecked = true;
      }
    });
    this.productosValid = somechecked;
  }

  saveName() {
    if (!this.permisoName.trim().length) {
      this.permisoName = 'No Valido';
    }
    this.permisoName = this.permisoName.trim();
    this.editNameMode = false;
  }

  checkValidDescription() {
    this.descError = this.descripcion.trim().length === 0;
  }

  public setPermiso(permiso: any) {
    this.permisoLoaded = permiso;
    this.setupData(this.permisoLoaded);
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/permisos-detail/permisos-detail.component.ts